import {
	ShareableTypes,
	ShareWithGroupsOrStudentsCommand,
	UserGroupWithStudentsDto
} from './../models/models';
import { IHasId, IHasTitle } from './../redux/projects/projects.types';
import { UserGroupDto, ShareWithGroupCommand } from '../models';
import { HttpResponse } from '../redux';
import { hasFailed } from '../utils';
import { get, post } from './HttpService';
import { dispatchSnackbar } from './SnackbarService';
import i18next from '../i18n/i18nInit';

export async function getGroups(): Promise<UserGroupDto[]> {
	const response: HttpResponse<UserGroupDto[]> = await get<UserGroupDto[]>(
		'user',
		'user/groups'
	);

	return response.data!;
}

export async function getGroupsWithStudents(): Promise<
	UserGroupWithStudentsDto[]
> {
	const response: HttpResponse<UserGroupWithStudentsDto[]> = await get<
		UserGroupWithStudentsDto[]
	>(`user`, `user/groups/students`);

	return response.data!;
}

export async function shareWithGroup(
	groups: UserGroupDto[],
	item: IHasId & IHasTitle,
	type: ShareableTypes
): Promise<void> {
	const command: ShareWithGroupCommand = {
		groupIds: groups.map((group: UserGroupDto) => group.id),
		id: item.id as string,
		type
	};
	const response: HttpResponse<{}> = await post<{}, ShareWithGroupCommand>(
		'user',
		'user/share/groups',
		command
	);

	const groupName: string | undefined =
		groups.length > 1
			? i18next.t('user:amountClasses', { amount: groups.length })
			: groups[0].name;

	const failed: boolean = hasFailed(response, true);
	const message: string = failed
		? i18next.t('user:sharingFailed', { title: item.title, groupName })
		: i18next.t('user:sharingSucceeded', {
				title: item.title,
				groupName
		  });

	dispatchSnackbar('user', 'POST', true, message);
}

export async function shareWithGroupsOrStudents(
	groupIds: string[],
	studentIds: string[],
	projectIds: string[],
	comparisonIds: string[]
): Promise<void> {
	const command: ShareWithGroupsOrStudentsCommand = {
		groupIds,
		studentIds,
		projectIds,
		comparisonIds
	};

	const response: HttpResponse<{}> = await post<
		{},
		ShareWithGroupsOrStudentsCommand
	>(`user`, `user/share/multi`, command);

	const failed: boolean = hasFailed(response, true);
	const message: string = failed
		? i18next.t('user:mapSharingFailed')
		: i18next.t('user:mapSharingSucceeded');

	dispatchSnackbar(`user`, `POST`, true, message);
}
